/* Landing page – etkileşimler */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function inView(el, cb, opts) {
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { cb(e.isIntersecting); });
    }, opts || { threshold: 0.35 }).observe(el);
  }

  /* Galeri */
  function initGallery(g) {
    var track = g.querySelector('.lp-gallery__track');
    var slides = track.children;
    var thumbs = g.querySelectorAll('.lp-gallery__thumb');
    function index() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(i) {
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    function mark() {
      var i = index();
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (thumbs[i]) thumbs[i].scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    var prev = g.querySelector('.lp-gallery__arrow--prev');
    var next = g.querySelector('.lp-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
    var timer;
    track.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(mark, 80); });
  }

  /* Paket seçimi + sepete ekleme */
  function initBundles(form) {
    var bundles = form.querySelectorAll('.lp-bundle');
    var err = form.querySelector('.lp-error');
    function select(b) {
      bundles.forEach(function (x) { x.classList.toggle('is-selected', x === b); });
      b.querySelector('input[type=radio]').checked = true;
    }
    bundles.forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (e.target.closest('select')) return;
        select(b);
      });
    });

    function items() {
      var b = form.querySelector('.lp-bundle.is-selected') || bundles[0];
      var map = {};
      var selects = b.querySelectorAll('select[data-unit]');
      if (selects.length) {
        selects.forEach(function (s) { map[s.value] = (map[s.value] || 0) + 1; });
      } else {
        map[b.dataset.variant] = parseInt(b.dataset.qty, 10) || 1;
      }
      return Object.keys(map).map(function (id) {
        return { id: parseInt(id, 10), quantity: map[id], properties: b.dataset.label ? { 'Paket': b.dataset.label } : undefined };
      });
    }

    function add(btn, redirect) {
      err.textContent = '';
      btn.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items() })
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || res.d.message || 'Sepete eklenemedi');
          document.dispatchEvent(new CustomEvent('lp:added', { detail: res.d }));
          window.location.href = redirect;
        })
        .catch(function (e) { err.textContent = e.message; btn.disabled = false; });
    }

    /* Seçili paketi standart ürün formuna yansıt (COD/paket uygulamaları bu alanları okur) */
    var idInput = form.querySelector('[data-lp-id]');
    var qtyInput = form.querySelector('[data-lp-qty]');
    var returnInput = form.querySelector('[data-lp-return]');
    function sync() {
      var b = form.querySelector('.lp-bundle.is-selected');
      if (!b || !idInput || !qtyInput) return;
      var first = b.querySelector('select[data-unit]');
      idInput.value = first ? first.value : b.dataset.variant;
      qtyInput.value = b.dataset.qty || 1;
    }
    bundles.forEach(function (b) { b.addEventListener('click', function () { setTimeout(sync, 0); }); });
    form.addEventListener('change', function (e) { if (e.target.matches('select[data-unit]')) sync(); });
    sync();

    form.querySelectorAll('[data-buy]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var redirect = btn.dataset.redirect || root + 'checkout';
        if (returnInput) returnInput.value = redirect;
        /* Kendi paket seçicimiz yoksa (Kaching vb.) standart form gönderimi uygulamaya bırakılır */
        if (!bundles.length) return;
        e.preventDefault();
        add(btn, redirect);
      });
    });
  }

  /* Sayfa içi bağlantılar (#lp-main vb.): temadan bağımsız, yumuşak kaydırma */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link || !link.closest('.lp')) return;
    var id = link.getAttribute('href').slice(1);
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    var header = document.querySelector('.shopify-section-header-sticky, header.header, .header-wrapper, sticky-header');
    var offset = (header ? Math.min(header.getBoundingClientRect().height, 140) : 0) + 12;
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(y, 0), behavior: 'smooth' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  }, true);

    /* Modal */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-modal-open]');
    if (open) {
      var m = document.getElementById(open.dataset.modalOpen);
      if (m) { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-modal-close]')) {
      var mm = e.target.closest('.lp-modal');
      mm.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.lp-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.documentElement.style.overflow = '';
  });

  /* cc sayacı: 0 → max, döngüsel */
  function initCounter(el) {
    var max = parseInt(el.dataset.max, 10) || 100;
    var dur = 3200, raf, start, running = false;
    var out = el.querySelector('[data-count]');
    function tick(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      out.textContent = Math.round(max * p);
      if (p < 1) raf = requestAnimationFrame(tick);
      else setTimeout(function () { if (running) { start = null; raf = requestAnimationFrame(tick); } }, 1400);
    }
    inView(el, function (v) {
      if (v && !running) { running = true; start = null; raf = requestAnimationFrame(tick); }
      if (!v) { running = false; cancelAnimationFrame(raf); }
    });
  }

  /* Adımlar: sırayla aktifleşir */
  function initSteps(wrap) {
    var steps = wrap.querySelectorAll('.lp-step');
    var bar = wrap.querySelector('.lp-progress i');
    var interval = (parseInt(wrap.dataset.interval, 10) || 3) * 1000;
    var i = 0, t0, raf, running = false;
    function set(k) { steps.forEach(function (s, j) { s.classList.toggle('is-active', j === k); }); }
    function loop(t) {
      if (!t0) t0 = t;
      var p = (t - t0) / interval;
      if (p >= 1) { i = (i + 1) % steps.length; set(i); t0 = t; p = 0; }
      if (bar) bar.style.width = (((i + p) / steps.length) * 100) + '%';
      raf = requestAnimationFrame(loop);
    }
    steps.forEach(function (s, k) { s.addEventListener('click', function () { i = k; set(k); t0 = null; }); });
    set(0);
    inView(wrap, function (v) {
      if (v && !running) { running = true; t0 = null; raf = requestAnimationFrame(loop); }
      if (!v) { running = false; cancelAnimationFrame(raf); }
    }, { threshold: 0.2 });
  }

  /* Video oynat butonu */
  function initVideo(v) {
    var video = v.querySelector('video');
    var btn = v.querySelector('.lp-video__play');
    if (!video || !btn) return;
    btn.addEventListener('click', function () { video.muted = false; video.controls = true; video.play(); v.classList.add('is-playing'); });
    video.addEventListener('pause', function () { v.classList.remove('is-playing'); });
  }

  /* Görünürken otomatik oynayan videolar */
  function initAutoVideo(video) {
    inView(video, function (vis) { if (vis) { var p = video.play(); if (p) p.catch(function () {}); } else video.pause(); }, { threshold: 0.2 });
  }

  /* Yazılı yorumlar: ilk N tanesi görünür, butonla N'er N'er açılır */
  function initReviews(list) {
    var step = parseInt(list.dataset.step, 10) || 5;
    var cards = list.querySelectorAll('.lp-trev__card');
    var shown = step;
    var btn = list.parentElement.querySelector('[data-trev-more]');
    function render() {
      cards.forEach(function (c, i) { c.classList.toggle('is-hidden', i >= shown); });
      if (btn) btn.hidden = shown >= cards.length;
    }
    if (btn) btn.addEventListener('click', function () { shown += step; render(); });
    render();
  }

  /* Video yorum kartı: görünürken sessiz oynar, butonla ses açılır (aynı anda tek sesli video) */
  function initVideoReview(card) {
    var video = card.querySelector('video');
    var btn = card.querySelector('.lp-vrev__sound');
    if (!video) { if (btn) btn.hidden = true; return; }
    initAutoVideo(video);
    function toggle() {
      var on = video.muted;
      document.querySelectorAll('.lp-vrev__card.is-sound').forEach(function (c) {
        if (c !== card) { c.classList.remove('is-sound'); c.querySelector('video').muted = true; }
      });
      video.muted = !on;
      card.classList.toggle('is-sound', on);
      if (on) { var p = video.play(); if (p) p.catch(function () {}); }
    }
    btn.addEventListener('click', function (e) { e.stopPropagation(); toggle(); });
    video.addEventListener('click', toggle);
  }

  /* Sabit alt bar: ana satın al butonları görünmezken çıkar */
  function initSticky(bar) {
    var target = document.querySelector('[data-lp-buy-anchor]');
    if (!target) { bar.classList.add('is-visible'); return; }
    function update() { bar.classList.toggle('is-visible', target.getBoundingClientRect().bottom < 0); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function init(scope) {
    scope.querySelectorAll('.lp-gallery:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initGallery(el); });
    scope.querySelectorAll('[data-bundle-form]:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initBundles(el); });
    scope.querySelectorAll('.lp-counter:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initCounter(el); });
    scope.querySelectorAll('.lp-steps:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initSteps(el); });
    scope.querySelectorAll('.lp-video:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initVideo(el); });
    scope.querySelectorAll('[data-trev]:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initReviews(el); });
    scope.querySelectorAll('.lp-vrev__card:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initVideoReview(el); });
    scope.querySelectorAll('.lp-fit__item video:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initAutoVideo(el); });
    scope.querySelectorAll('.lp-sticky:not([data-ready])').forEach(function (el) { el.dataset.ready = 1; initSticky(el); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  /* Tema editöründe bölüm yeniden yüklenince */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
